import { createTheme } from '@mui/material/styles'
import constants from '../../constants'

const adminTheme = createTheme({
  palette: {
    primary: {
      main: constants.colors.primary[700],
      contrastText: constants.colors.neutrals.white,
    },
    secondary: {
      main: constants.colors.primary[100],
      contrastText: constants.colors.primary[500],
    },
  },
  shape: { borderRadius: 8 },
})

export default adminTheme
